import React from 'react';
import Logo from '../../../components/Logo';
import { SchoolInfoContainer, SchoolName } from './styled';
import { SchoolConfig } from '../../../types/schoolConfigType';

interface SchoolInfoProps {
  school: string;
  schoolConfig: SchoolConfig;
}

const SchoolInfo = ({ school, schoolConfig }: SchoolInfoProps) => {
  return (
    <SchoolInfoContainer>
      <Logo school={school} schoolConfig={schoolConfig} />
      <SchoolName>{school}</SchoolName>
    </SchoolInfoContainer>
  );
};

export { SchoolInfo };
